var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"headers":_vm.headers,"promise":_vm.promise,"disablePagination":true},scopedSlots:_vm._u([{key:"item.cancellationDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTimeSeconds")(item.cancellationDate))+" ")]}},{key:"item.purchaseDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTimeSeconds")(item.purchaseDate))+" ")]}},{key:"item.originalPurchaseDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTimeSeconds")(item.originalPurchaseDate))+" ")]}},{key:"item.expiresDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTimeSeconds")(item.expiresDate))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }